import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { WhitelabelConfigStore } from '../core/config/whitelabel-config.store';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContactusComponent {
  readonly contactForm: UntypedFormGroup;
  submitted = false;
  sent = false;

  constructor(
    formBuilder: UntypedFormBuilder,
    public readonly configStore: WhitelabelConfigStore
  ) {
    this.contactForm = formBuilder.group({
      name: ['', [Validators.required, Validators.minLength(2)]],
      email: ['', [Validators.required, Validators.email]],
      message: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  get config() {
    return this.configStore.snapshot.config;
  }

  get supportEmail(): string {
    return this.config?.site?.supportEmail || 'reports@masheastafrica.com';
  }

  get supportNumber(): string {
    return this.config?.site?.supportNumber || '+254 733 623 260';
  }

  get supportPhoneHref(): string {
    return `tel:${this.supportNumber.replace(/[^\d+]/g, '')}`;
  }

  get contactContent(): Record<string, any> {
    return this.configStore.getConfig('content.contact', {});
  }

  get frequentlyAskedQuestions(): Array<{ question: string; answer: string }> {
    return this.contactContent['faq'] || [];
  }

  submit(): void {
    this.submitted = true;
    if (this.contactForm.invalid) {
      this.contactForm.markAllAsTouched();
      return;
    }
    this.sent = true;
  }

  sendAnother(): void {
    this.contactForm.reset();
    this.submitted = false;
    this.sent = false;
  }
}
